<template>
	<div v-if="visible" class="status-container d-flex align-center status pa-1" :class="`status-${getStatusLower()}`">
		<v-icon class="mr-1" :class="`status-icon status-${getStatusLower()} status-mobile`">{{ getStatusIcon(status) }}</v-icon>
		<span :class="`white-space:nowrap status-text `">{{ translateStatus() }}</span>
	</div>
</template>

<script setup lang="ts">
	import { getIconForInitiator, Initiator } from "@/enums/Initiator";
	import { EntityType } from "@/types/EntityType";
	import { computed, onMounted, ref } from "vue";
	import { translateConversationStatus, translateProjectStatus } from "@/helpers/status";
	import { getStatusIcon } from "@/helpers/statusIcon";
	import constants from "@/api/constants";

	const initiator = ref<Initiator>(Initiator.RECORDING);

	const props = defineProps<{
		status: string;
		entityType: EntityType;
		initiator: Initiator;
		appointmentName: string;
		sourceType: string;
	}>();

	// Only show the status for conversations on mobile that are not "Not Started" because it shows a hyphen and doesn't look good

	const visible = computed(() => {
		return (
			(props.entityType === "conversation" && props.status !== constants.CONVERSATION_STATUS.NotStarted) ||
			props.entityType === "project"
		);
	});

	onMounted(() => {
		initiator.value = props.initiator;
	});

	function translateStatus(): string {
		if (props.entityType === "conversation") {
			return translateConversationStatus(props.status);
		} else if (props.entityType === "project") {
			return translateProjectStatus(props.status);
		}

		return props.status;
	}

	function getStatusLower(): string {
		if (props.status === null || props.status === undefined || props.status.trim().length == 0) return "";
		return props.status.toLowerCase();
	}

	function getIconForConversation() {
		// this feels like a hack but right now, the only way to differentiate
		// between a scheduled and live video call is by checking if the appointment is null.
		// TODO: fix this
		if (props.initiator == Initiator.SCHEDULED_VIDEO && props.appointmentName == null) {
			initiator.value = Initiator.LIVE_VIDEO;
		}
		if (props.sourceType == "FORM") {
			initiator.value = Initiator.FORM;
		}
		return getIconForInitiator(initiator.value);
	}
</script>

<style scoped lang="scss">
	.status-container {
		flex: 0 0 auto;
		white-space: nowrap;
	}

	.status {
		border-radius: 5px;
		font-size: 0.625rem;
	}

	.status-icon {
		font-size: 0.85rem;
		height: 16px;
		width: 16px;
		border-radius: 12px;
	}

	/* this shoves the left side of the text out and under the chip */
	.status-text {
	}
</style>
